import { GET_PRODUCT_REVIEWS_BY_PRODUCT, PRODUCT_REVIEW } from "../redux/apis";
import { axiosAuthInstance, axiosPublicInstance } from "../redux/axiosInstance";


export const getProductReviews = async (productId: any) => {
    if (productId) {
        try {
            const response = await axiosPublicInstance.get(`${GET_PRODUCT_REVIEWS_BY_PRODUCT}${productId}`);
            if (response) {
                return response.data;
            } else {
                console.warn("Empty response");
                return null;
            }
        } catch (error) {
            console.error("Error:", error);
        }
    }
};

export const postReviews = async (orderId: any, productId: any, reviewHeadLine: any, reviewText: any, rating: any) => {
    let params = {
        "productReviewId": 0,
        "productId": productId,
        "customerId": localStorage.getItem("customerId"),
        "orderId": orderId,
        "rating": rating,
        "reviewHeadline": reviewHeadLine,
        "reviewText": reviewText
    };
    try {
        const response: any = await axiosAuthInstance.post(PRODUCT_REVIEW, params);
        if (response) {
            return response.data;
        }
    } catch (error) {
        console.error(error);
        return error;
    }
};